
import { TutorialStep } from "@/components/tutorial/TutorialSpotlight";

// Export the tutorial steps for the Home page
export const shoppingHeaderTutorial: TutorialStep[] = [
  {
    target: ".tutorial-target-shoppingheader-search",
    title: "Filtra prodotti",
    content: "Puoi filtrare i prodotti per nome, stato o categoria. In questo modo puoi trovare rapidamente ciò che stai cercando.",
  },
  {
    target: ".tutorial-target-shoppingheader-shops",
    title: "Riordina per negozio",
    content: "Puoi riordinare i prodotti in base al negozio in cui li acquisterai. Questo ti aiuterà a fare la spesa in modo più efficiente.",
  },
  {
    target: ".tutorial-target-shoppingheader-rapid",
    title: "Inserimento rapido",
    content: "Puoi inserire rapidamente gli articoli senza la necessità di scegliere la quantità. Questo ti farà risparmiare tempo quando dovrai creare la lista della spesa.",
  },
  {
    target: ".tutorial-target-shoppingheader-mode",
    title: "Modalità lista",
    content: "Usa questi pulsanti per passare tra modalità Spesa e Prepara. Nella modalità spesa vedi solamente i prodotti da acquistare. Nella modalità prepara puoi vedere i prodotti già acquistati per rimetterli velocemente in lista.",
  },
  {
    target: ".tutorial-target-productcard",
    title: "Prodotti Lista",
    content: "Puoi spuntare l'articolo come comprato con un tap ed entrare nelle opzioni avanzate con un tap prolungato. Nelle opzioni avanzate puoi gestire quantità, attributi o eliminare l'articolo dalla lista."
  },
  {
    target: ".tutorial-target-shoppingheader-additem",
    title: "Aggiunta articolo",
    content: "Puoi utilizzare questo tasto per aggiungere prodotti alla tua lista o crearne di nuovi.",
  }
];

